// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__8S_dN","favourited-text":"style_favourited-text__tIChU","icon":"style_icon__gvHi6"};